<div class="text-container">
    <button class="delete" (click)="deleteDocument()" aria-label="delete"> </button>
    <span class="text-portion" [title]="'uploaded file: ' + fileWidget.fileName"
        [ngClass]="{'error': fileWidget.error}">{{displayName}}</span>
</div>
<progress *ngIf="fileWidget.progress > 0 && fileWidget.progress < 200" class="progress-bar"
    [value]="fileWidget.progress" [max]=200></progress>